import React from 'react';

import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

interface Props {
  body: React.ReactNode;
  confirmingText?: string;
  isConfirming?: boolean;
  open: boolean;
  title: string;
  onClose: () => void;
  onConfirm: () => void;
}

export default function DeleteConfirmationDialog({
  body,
  confirmingText = 'Deleting...',
  isConfirming,
  open,
  title,
  onClose,
  onConfirm,
}: Props) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{body}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="text" disabled={isConfirming} onClick={onClose}>
          Cancel
        </Button>
        <Button variant="contained" color="error" disabled={isConfirming} onClick={onConfirm}>
          {isConfirming ? confirmingText : 'Delete'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
